/**
 * Keeps the displayed price in step with the selected variant.
 *
 * Correctness does not depend on this file: the variant <select> posts
 * `name="id"`, so the right variant is added to the cart even if this script
 * never runs. All it does is update what the page shows.
 *
 * Money strings are rendered by Liquid into data-attributes so the store's
 * own currency format is used, rather than being re-implemented here.
 *
 * Delegated from the document so sections re-rendered by the theme editor
 * keep working without re-binding.
 */
(function () {
  'use strict';

  function update(select) {
    var root = select.closest('[data-product-root]');
    if (!root) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var price = root.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price || '';

    var compare = root.querySelector('[data-product-compare-price]');
    if (compare) compare.textContent = option.dataset.comparePrice || '';

    var button = root.querySelector('[data-add-button]');
    if (button) {
      var available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available
        ? button.dataset.labelAdd
        : button.dataset.labelSoldOut;
    }

    // Keep the URL shareable and correct on reload. Never let a URL problem
    // break the price update above.
    try {
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
    } catch (error) {
      /* non-fatal */
    }
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-variant-select]');
    if (select) update(select);
  });
})();
